export const SECTION_ORDER_COOKIE_NAME = 'dashboard_surface_section_order'
export const HIDDEN_SECTIONS_COOKIE_NAME = 'dashboard_surface_hidden_sections'
export const COMPACT_MODE_COOKIE_NAME = 'dashboard_surface_compact_mode'
export const MAX_PR_AGE_COOKIE_NAME = 'dashboard_surface_max_pr_age'
export const PULLS_DEFAULT_VIEW_COOKIE_NAME = 'dashboard_surface_pulls_default_view'
export const ISSUES_DEFAULT_VIEW_COOKIE_NAME = 'dashboard_surface_issues_default_view'
